import { c as _c } from "react/compiler-runtime";
import { readFragment } from "@opensea/graphql";
import { TeamModuleFragment } from "./TeamModule.fragment";
import { TeamModuleLayout } from "./TeamModuleLayout";
export function TeamModule(t0) {
  const $ = _c(4);
  const {
    module: moduleKey
  } = t0;
  let t1;
  if ($[0] !== moduleKey) {
    t1 = readFragment(TeamModuleFragment, moduleKey);
    $[0] = moduleKey;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const moduleData = t1;
  let t2;
  if ($[2] !== moduleData) {
    t2 = <TeamModuleLayout {...moduleData} />;
    $[2] = moduleData;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}